import React from "react";

interface AppPromoBannerProps {
  className?: string;
}

const AppPromoBanner: React.FC<AppPromoBannerProps> = ({ className }) => {
  return (
    <section
      className={`relative overflow-hidden bg-cover bg-center py-16 ${className || ""}`}
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1491002052546-bf38f186af56?w=1920&h=600&fit=crop')",
      }}
    >
      <div className="absolute inset-0 bg-black/30" />
      <div className="relative z-10 px-4 sm:px-8 lg:px-24">
        <div className="content-container">
          <div className="max-w-xl">
          <h2 className="text-3xl font-bold leading-tight text-white sm:text-4xl">
            <span className="block">Conçue</span>
            <span className="block text-meteoyellow-500">pour la</span>
            <span className="block text-meteoyellow-500">météo d'ici.</span>
          </h2>
          <p className="mt-4 text-lg text-white/90">
            (Enfin, la météo de là-bas, ou de n'importe où, on ne sait plus)
          </p>
          <a
            href="#"
            className="mt-6 inline-block rounded-lg bg-red-500 px-6 py-3 font-semibold text-white hover:bg-red-600"
          >
            Téléchargez l'appli
          </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromoBanner;
